/**
 * Seenly Jewelry — Gift Finder! System
 * Interactive wizard modal inspired by Jeulia (jeulia.com)
 */
class SeenlyGiftFinder {
  constructor() {
    this.state = {
      recipient: '',
      occasion: '',
      budget: '',
      category: ''
    };
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    const dialog = document.getElementById('gift-finder-dialog');
    if (!dialog) return;

    // Handle chip click
    dialog.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-gf-chip]');
      if (chip) {
        const group = chip.getAttribute('data-gf-group');
        const value = chip.getAttribute('data-gf-value');

        // Toggle or select
        if (this.state[group] === value) {
          this.state[group] = '';
          chip.classList.remove('bg-accent', 'text-white', 'border-accent');
          chip.classList.add('bg-surface', 'text-on-surface', 'border-border');
          chip.setAttribute('aria-pressed', 'false');
        } else {
          // Deselect siblings in same group
          dialog.querySelectorAll(`[data-gf-chip][data-gf-group="${group}"]`).forEach(btn => {
            btn.classList.remove('bg-accent', 'text-white', 'border-accent');
            btn.classList.add('bg-surface', 'text-on-surface', 'border-border');
            btn.setAttribute('aria-pressed', 'false');
          });

          this.state[group] = value;
          chip.classList.remove('bg-surface', 'text-on-surface', 'border-border');
          chip.classList.add('bg-accent', 'text-white', 'border-accent');
          chip.setAttribute('aria-pressed', 'true');
        }

        this.updateSummary();
        return;
      }

      // Handle Reset
      const resetBtn = e.target.closest('[data-gf-reset]');
      if (resetBtn) {
        this.reset();
        return;
      }

      // Handle Submit
      const submitBtn = e.target.closest('[data-gf-submit]');
      if (submitBtn) {
        this.submit();
        return;
      }
    });
  }

  reset() {
    this.state = { recipient: '', occasion: '', budget: '', category: '' };
    const dialog = document.getElementById('gift-finder-dialog');
    if (!dialog) return;

    dialog.querySelectorAll('[data-gf-chip]').forEach(btn => {
      btn.classList.remove('bg-accent', 'text-white', 'border-accent');
      btn.classList.add('bg-surface', 'text-on-surface', 'border-border');
      btn.setAttribute('aria-pressed', 'false');
    });

    this.updateSummary();
  }

  updateSummary() {
    const summaryEl = document.getElementById('gift-finder-summary');
    if (!summaryEl) return;

    const parts = [];
    if (this.state.recipient) parts.push(this.state.recipient);
    if (this.state.occasion) parts.push(this.state.occasion);
    if (this.state.category) parts.push(this.state.category);
    if (this.state.budget) parts.push(this.state.budget);

    if (parts.length > 0) {
      summaryEl.textContent = `Selected: ${parts.join(' · ')}`;
      summaryEl.classList.remove('hidden');
    } else {
      summaryEl.textContent = '';
      summaryEl.classList.add('hidden');
    }
  }

  submit() {
    let baseUrl = '/collections/all';
    const params = new URLSearchParams();

    // Specific category collection shortcuts
    if (this.state.category === 'Sets' || this.state.category === 'Jewelry Sets') {
      baseUrl = '/collections/pearl-jewelry-set';
    }

    // Budget price ranges
    if (this.state.budget === '<50') {
      params.append('filter.v.price.lte', '50.00');
    } else if (this.state.budget === '50-99') {
      params.append('filter.v.price.gte', '50.00');
      params.append('filter.v.price.lte', '99.00');
    } else if (this.state.budget === '99-150') {
      params.append('filter.v.price.gte', '99.00');
      params.append('filter.v.price.lte', '150.00');
    } else if (this.state.budget === '>150') {
      params.append('filter.v.price.gte', '150.00');
    }

    // Keyword queries
    const terms = [];
    if (this.state.occasion && this.state.occasion !== 'Just Because') {
      terms.push(this.state.occasion);
    }
    if (this.state.category && this.state.category !== 'All Styles' && !baseUrl.includes('pearl-jewelry-set')) {
      terms.push(this.state.category);
    }

    if (terms.length > 0) {
      params.append('q', terms.join(' '));
    }

    const queryString = params.toString();
    const targetUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    window.location.href = targetUrl;
  }
}

window.SeenlyGiftFinder = new SeenlyGiftFinder();
export default window.SeenlyGiftFinder;
